import { FuelingPump } from './pages/FuelingPump/FuelingPump';

export const App = () => {
  return <FuelingPump />;
};
